module.exports = __webpack_public_path__ + "static/img/htmmis-book.1381d99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/htmmis-book.jpg
// module id = Upb+
// module chunks = 1